import { Card, CardHeader, CardTitle } from '@/components/ui/Card';
import type { ClientRecord } from '@/api/clients';
import { fmtDob } from '../clientHelpers';
import { DetailList } from './DetailList';

export function ClientOverviewTab({ client: c }: { client: ClientRecord }) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <Card>
                <CardHeader><CardTitle>Snapshot</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Date of birth',    value: fmtDob(c.dob) },
                        { label: 'Gender',           value: c.gender },
                        { label: 'Intake',           value: c.intake ? fmtDob(c.intake) : '—' },
                        { label: 'Supervising BCBA', value: c.bcba },
                    ]}
                />
            </Card>

            <Card>
                <CardHeader><CardTitle>Diagnoses</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Primary diagnosis',          value: c.dx1 },
                        { label: 'Primary dx date',            value: c.dx1Date ? fmtDob(c.dx1Date) : '—' },
                        { label: 'Primary diagnosing provider', value: c.dx1ProviderName },
                        { label: 'Primary provider NPI',       value: c.dx1ProviderNpi },
                        { label: 'Secondary diagnosis',        value: c.dx2 },
                        { label: 'Secondary dx date',          value: c.dx2Date ? fmtDob(c.dx2Date) : '—' },
                        { label: 'Secondary diagnosing provider', value: c.dx2ProviderName },
                        { label: 'Secondary provider NPI',     value: c.dx2ProviderNpi },
                    ]}
                />
            </Card>

            <Card className="lg:col-span-2">
                <CardHeader><CardTitle>Parent/Guardian</CardTitle></CardHeader>
                <DetailList
                    items={[
                        { label: 'Name',         value: c.gname },
                        { label: 'Relationship', value: c.grel },
                        { label: 'Phone',        value: c.gphone },
                        { label: 'Email',        value: c.gemail },
                    ]}
                />
            </Card>

            <Card className="lg:col-span-2">
                <CardHeader><CardTitle>Clinical Notes</CardTitle></CardHeader>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <div className="text-2xs font-bold uppercase tracking-wider text-text-subtle mb-1">
                            Developmental history
                        </div>
                        <p className="text-sm whitespace-pre-wrap">
                            {c.developmentalHistory || <span className="text-text-subtle">—</span>}
                        </p>
                    </div>
                    <div>
                        <div className="text-2xs font-bold uppercase tracking-wider text-text-subtle mb-1">
                            Medical
                        </div>
                        <p className="text-sm whitespace-pre-wrap">
                            {c.medical || <span className="text-text-subtle">—</span>}
                        </p>
                    </div>
                </div>
            </Card>
        </div>
    );
}
